import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  private defaultConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom'
  };

  /**
   * Show a success notification
   */
  success(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.open(message, 'OK', {
      ...this.defaultConfig,
      ...config,
      panelClass: ['success-snackbar']
    });
  }

  /**
   * Show an info notification
   */
  info(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.open(message, 'OK', {
      ...this.defaultConfig,
      ...config,
      panelClass: ['info-snackbar']
    });
  }

  /**
   * Show an error notification
   */
  error(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.open(message, 'Virhe', {
      ...this.defaultConfig,
      ...config,
      panelClass: ['error-snackbar']
    });
  }

  /**
   * Get user-friendly error message based on HTTP error
   * @param error The HTTP error response
   * @returns Localized user-friendly error message
   */
  handleHttpError(error: HttpErrorResponse): string {
    // Default error messages based on HTTP status
    // TODO: Re-think the messages based on application's needs
    switch (error.status) {
      case 401:
        return 'Kirjautuminen on vanhentunut. Ole hyvä ja kirjaudu uudelleen.';
      case 403:
        return 'Sinulla ei ole oikeuksia tähän toimintoon.';
      case 404:
        return 'Pyydettyä resurssia ei löytynyt.';
      case 409:
        return 'Tietojen tallennus epäonnistui (konfliktitilanne).';
      case 422:
        return 'Lähetetyt tiedot ovat virheelliset.';
      case 500:
        return 'Palvelimella tapahtui virhe. Yritä myöhemmin uudelleen.';
      default: {
        // Try to get a message from the response
        const serverMessage = error.error?.message || error.message;
        return serverMessage || 'Tapahtui odottamaton virhe.';
      }
    }
  }
}
